(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitrine-comercial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('commercial-showcase')) {
    customElements.define('commercial-showcase', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-vc-viewport]');
        this.track = this.querySelector('[data-vc-track]');
        this.controls = this.querySelector('[data-vc-controls]');
        this.previousButton = this.querySelector('[data-vc-previous]');
        this.nextButton = this.querySelector('[data-vc-next]');
        this.progress = this.querySelector('[data-vc-progress]');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.strength = Math.min(18, Math.max(0, Number(this.dataset.strength) || 0));
        this.visible = false;
        this.frame = null;

        if (!this.viewport || !this.track) return;

        this.onScroll = this.scheduleUpdate.bind(this);
        this.onResize = this.scheduleUpdate.bind(this);
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onCardClick = this.emitCardClick.bind(this);

        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.addEventListener('click', this.onCardClick);

        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0]?.isIntersecting || false;
          if (this.visible) this.scheduleUpdate();
        }, { rootMargin: '120px 0px' });
        this.observer.observe(this);
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.viewport?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.removeEventListener('click', this.onCardClick);
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      move(direction) {
        const amount = Math.max(280, this.viewport.clientWidth * 0.72);
        this.viewport.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const progress = maxScroll > 0 ? this.viewport.scrollLeft / maxScroll : 0;
        const hasOverflow = maxScroll > 2;

        if (this.controls) this.controls.hidden = !hasOverflow;
        if (this.previousButton) this.previousButton.disabled = !hasOverflow || this.viewport.scrollLeft <= 2;
        if (this.nextButton) this.nextButton.disabled = !hasOverflow || this.viewport.scrollLeft >= maxScroll - 2;
        if (this.progress) this.progress.style.transform = `scaleX(${hasOverflow ? Math.max(.08, progress) : 1})`;

        if (!this.visible || this.motionQuery.matches || this.strength === 0) {
          this.style.setProperty('--vc-bg-x', '0px');
          this.style.setProperty('--vc-bg-y', '0px');
          return;
        }

        const rect = this.getBoundingClientRect();
        const verticalProgress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const x = (.5 - progress) * this.strength * 2;
        const y = (.5 - verticalProgress) * this.strength * 2;
        this.style.setProperty('--vc-bg-x', `${x.toFixed(2)}px`);
        this.style.setProperty('--vc-bg-y', `${y.toFixed(2)}px`);
      }

      emitCardClick(event) {
        const link = event.target.closest('[data-vc-card] a');
        if (!link) return;
        const card = link.closest('[data-vc-card]');
        this.dispatchEvent(new CustomEvent('exallaxe:vitrine-card-click', {
          bubbles: true,
          detail: {
            context: this.dataset.context,
            showcase: this.dataset.showcase,
            productId: card.dataset.productId,
            productHandle: card.dataset.productHandle,
            position: Number(card.dataset.position)
          }
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
